module.exports = __webpack_public_path__ + "media/2.ef834eba.wav";